<div class="wrapper" [ngClass]="{active:toggle}">
  <div class="header">
    <p><strong>Quick Edit: {{ selection.length }}</strong> batch{{ (selection.length == 1) ? '' : 'es' }} selected</p>
    <svg (click)="trigger()" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1"
         stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
    </svg>
  </div>
  <div class="content">

    <accordion header="Batches" (change)="onAccordionChange($event)">
      <div class="field-input"
           *ngIf="selection.length == 1 && (userRole == Role.Alpha || userRole == Role.Clerk ||  userRole == Role.Manager)">
        <label>Tags</label>
        <tagger [values]="tags" (change)="onTagChange($event)"></tagger>
      </div>
      <div class="field-input" *ngIf="(userRole == Role.Alpha || userRole == Role.Clerk ||  userRole == Role.Manager)">
        <label>Status</label>
        <dropdown-filter placeholder="Select Status" (change)="onStatusChange($event)" [values]="status"
                         identifier="bsid"></dropdown-filter>
      </div>
      <div class="field-input"
           *ngIf="(userRole == Role.Alpha || userRole == Role.Clerk ||  userRole == Role.Manager)">
        <label>Estimated Arrival Time</label>
        <date-picker [is_range]="false" (change)="onEtaChange($event)"></date-picker>
      </div>
      <div class="field-input"
           *ngIf="(userRole == Role.Alpha || userRole == Role.Clerk ||  userRole == Role.Manager ||  userRole == Role.Trucker ||  userRole == Role.Importer)">
        <label>Pickup Status</label>
        <toggle (change)="onPickupChange($event)"></toggle>
      </div>
      <div class="field-input">
        <buttons (click)="onContentUpdate()" text_transform="uppercase">Update</buttons>
      </div>
    </accordion>


    <accordion header="Export / Print" [toggle]="true" (change)="onAccordionChange($event)">
      <div class="field-input">
        <label>Batches</label>
        <buttons (click)="onWorkspaceExport(filter)">Export Batches</buttons>
      </div>
      <div class="field-input">
        <label>Documents
          <span>
              <span *ngIf="document_type_presets.length > 0" (click)="toggleDocumentTypePreset()"
                    [ngClass]="{active: toggle_document_type_preset}">Presets</span>
              <span *ngIf="selected_document_types.length > 0" (click)="createDocumentTypePresetLoaded(undefined)"
                    [ngClass]="{active: toggle_document_type_preset}">{{ document_type_presets.length > 0 ? 'Create' : 'Create Preset' }}</span>
              <span *ngIf="selected_document_type_preset" (click)="updateDocumentTypePreset()"
                    [ngClass]="{active: toggle_document_type_preset}">Update</span>
          </span>
        </label>

        <ul class="preset" *ngIf="toggle_document_type_preset">
          <li *ngFor="let preset of document_type_presets" >
            <span (click)="selectDocumentTypePreset(preset)">{{ preset.name }}</span>
            <svg (click)="removeDocumentTypePreset(preset)" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round"
                    d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"/>
            </svg>
          </li>
        </ul>

        <div class="create-form" *ngIf="toggle_document_type_preset_create">
          <div class="field-input " style="padding-top: 0">
            <div class="inline">
              <input type="text" placeholder="Preset Name" #preset_name>
              <svg (click)="createDocumentTypePresetLoaded(preset_name.value)" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
              </svg>
            </div>
          </div>
        </div>

        <tag-dropdown [values]="document_types" [selected]="selected_document_types"
                      (change)="onDocumentTypeDownloadChange($event)" identifier="dtid"
                      label="name" placeholder="Select Document Types"></tag-dropdown>
        <div class="selected-preset" *ngIf="selected_document_type_preset">Preset: {{selected_document_type_preset.name}}</div>
        <div class="spacer" *ngIf="!selected_document_type_preset"></div>
        <label>Prefix</label>
        <tag-dropdown [values]="document_prefix" (change)="onDocumentPrefixDownloadChange($event)" identifier="value"
                      label="name" placeholder="Select Prefix"></tag-dropdown>
        <div class="spacer"></div>
        <div class="inline">
          <buttons (click)="onDownloadDocumentClick()">Download Documents</buttons>
          <buttons (click)="onPrintDocumentClick()">Print Documents</buttons>
        </div>
      </div>
    </accordion>


    <accordion header="ask <i>A</i>b<i>i</i>&sup2;&trade;" (change)="onAccordionChange($event)"
               [disable]="!(userRole == Role.Alpha || userRole == Role.Clerk || userRole == Role.Manager )">
      <div class="field-input">
        <label>Tasks</label>
        <tag-dropdown [values]="document_request" (change)="onDocumentRequestChange($event)" identifier="value"
                      label="name" placeholder="Select Tasks"></tag-dropdown>
        <div class="spacer"></div>
        <div class="inline">
          <buttons (click)="onDocumentRequestClick()">Request</buttons>
        </div>
      </div>
    </accordion>

  </div>

</div>
<div class="overlay" (click)="trigger()"></div>
